import { TokenManager, OAuth2Client, FRUser } from "@forgerock/javascript-sdk";
import { resetLoading } from "../../redux/actions/claimsAction";
import { clearUser } from "../../redux/slices/userSlice";
import { clearFeatureFlags } from "../../redux/slices/featureFlagsSlice";
import { store } from "../../redux/store";


export const OauthLogout = async () => {
  store.dispatch(clearUser());
  store.dispatch(clearFeatureFlags());
  store.dispatch(resetLoading());
  //end the current access token/session
  await OAuth2Client.endSession();
  //force reauthing to return to the login.
  await TokenManager.getTokens({ login: "redirect", forceRenew: true });
};

export const hardLogout = async () => {
  store.dispatch(clearUser());
  store.dispatch(clearFeatureFlags());
  store.dispatch(resetLoading());
  await FRUser.logout();
}